export default "__VITE_ASSET__b7f29ba4__"